module.exports = __webpack_public_path__ + "static/media/28.6675e3c4.jpg";